import React from "react";

import {
  Show,
  TextField,
  SimpleShowLayout,
  ReferenceField,
  DateField
} from "admin-on-rest";
import {viewStyle} from "./style";
import ReferenceSelectGrid from "../../../components/ReferenceSelectGrid";
import ReportFilter from "./ReportFilter";
import ActionBar from "../../../components/CRM/ActionBar/";
import ReferenceArrayField from "../../../components/ReferenceArrayField";
import DeviceTextField from "./DeviceTextField"; 

class DeviceShowItem extends React.Component {
  // componentWillUnmount() {
  //   window.location.reload();
  // }
  render() {
    const props = {...this.props};
    return (
      <Show title="resources.devices.titleEdit" {...props}>
        <SimpleShowLayout {...props}>
          <ReferenceField
            style={viewStyle.textFieldStyle}
            label="resources.devices.fields.storeName"
            source="kiosk_id"
            reference="kiosks"
          >
            <TextField source="name" />
          </ReferenceField>

          <TextField
            style={viewStyle.textFieldStyle}
            label="resources.devices.fields.deviceSerialNumber"
            source="id"
          />

          <ReferenceArrayField
            label="resources.devices.reportsTable"
            source="report_ids"
            reference="reports"
            location={props.location}
            actions={
              <ActionBar
                createButton={false}
                deleteButton={false}
                withActionMenu={false}
              />
            }
            filters={<ReportFilter />}
          >
            <ReferenceSelectGrid
              options={{
                multiSelectable: false,
                selectable: false
              }}
              headerOptions={{
                adjustForCheckbox: false,
                displaySelectAll: false,
                enableSelectAll: false
              }}
              bodyOptions={{
                displayRowCheckbox: false,
                deselectOnClickaway: false,
                showRowHover: true
              }}
              rowOptions={{selectable: false}}
            >
              <DateField
                label="resources.devices.fields.timestamp"
                source="created_at"
              />
              <DeviceTextField
                label="resources.devices.fields.uptime"
                source="uptime"
                sortable={false}
              />
              <TextField
                label="resources.devices.fields.wifiConnectionName"
                source="wifi_name"
                sortable={false}
              />
              <TextField
                label="resources.devices.fields.application_version"
                source="application_version"
                sortable={false}
              />
            </ReferenceSelectGrid>
          </ReferenceArrayField>
        </SimpleShowLayout>
      </Show>
    );
  }
}

export default DeviceShowItem;


// WEBPACK FOOTER //
// ./src/containers/CRM/Devices/DeviceShowItem.js